/* Hallmark · component: Accordion · genre: modern-minimal · theme: maeiz-tokens */
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import React from "react";
import { clsx } from "clsx";
import { ChevronDown } from "lucide-react";

export const Accordion = AccordionPrimitive.Root;

export const AccordionItem = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Item>,
    React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
    <AccordionPrimitive.Item
        ref={ref}
        className={clsx("border-b border-neutral-border dark:border-white/10", className)}
        {...props}
    />
));
AccordionItem.displayName = "AccordionItem";

export const AccordionTrigger = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Header className="flex">
        <AccordionPrimitive.Trigger
            ref={ref}
            className={clsx(
                "flex flex-1 items-center justify-between py-3 text-start text-sm font-semibold text-neutral-dark outline-none transition-none dark:text-white",
                "hover:text-primary focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
                "[&[data-state=open]>svg]:rotate-180",
                className,
            )}
            {...props}
        >
            {children}
            <ChevronDown size={16} className="shrink-0 text-neutral-secondary" aria-hidden />
        </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = "AccordionTrigger";

export const AccordionContent = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Content
        ref={ref}
        className={clsx("overflow-hidden text-sm text-neutral-secondary data-[state=closed]:hidden", className)}
        {...props}
    >
        <div className="pb-3 pt-0">{children}</div>
    </AccordionPrimitive.Content>
));
AccordionContent.displayName = "AccordionContent";
